import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'environments/environment';
import { Cobertura } from '../models/cobertura';
import { Prospecto } from '../models/prospecto';
import { ValoresGarantizados } from '../models/valoresGarantizados';

const BACKEND_URL = environment.apiUrl;


@Injectable({
    providedIn: 'root'
})
export class ValoresGarantizaService {

    constructor(private http: HttpClient) { }

    private tablaValoresGarantizadosSub = new BehaviorSubject<ValoresGarantizados[]>(null);


    public setValoresGarantizados(tablaValoresGarantizados: ValoresGarantizados[]): void {
        this.tablaValoresGarantizadosSub.next(tablaValoresGarantizados);
    }

    public getValoresGarantizados(): Observable<ValoresGarantizados[]> {
        return this.tablaValoresGarantizadosSub.asObservable();
    }

    obtenerValoresGarantizados(prospecto: Prospecto): Observable<any> {
        return this.http.post<ValoresGarantizados>(BACKEND_URL + '/valoresGarantizados/', prospecto);
    }
}
